import { DialogTitle } from '@frontend-platform/ui-lib/ui';
import { Check, Loader } from 'lucide-react';
import { VALIDATION_PROGRESS_TITLE, VALIDATION_STAGES } from '../constants';

interface ValidationProgressProps {
  activeStage: number;
}

// Only ever rendered inside AddCriterionModal's <DialogContent>, in place of
// the form view's own <DialogTitle> — Radix requires exactly one somewhere
// in the tree for screen readers, and this view had none, since the plain
// heading it used to render isn't wired up as the dialog's accessible title.
export function ValidationProgress({ activeStage }: ValidationProgressProps) {
  return (
    <div className="p-6">
      <DialogTitle className="mb-4 font-semibold text-base text-foreground">
        {VALIDATION_PROGRESS_TITLE}
      </DialogTitle>
      <ul className="flex flex-col gap-3">
        {VALIDATION_STAGES.map((label, index) => {
          const isDone = index < activeStage;
          const isActive = index === activeStage;
          return (
            <li key={label} className="flex items-center gap-2">
              <span className="inline-flex h-4 w-4 shrink-0 items-center justify-center">
                {isDone ? (
                  <Check className="h-3 w-3 text-green-700" />
                ) : isActive ? (
                  <Loader className="h-3 w-3 animate-spin text-foreground" />
                ) : (
                  <span className="h-2 w-2 rounded-full border border-border" />
                )}
              </span>
              <span
                className={[
                  'text-sm',
                  isDone || isActive ? 'text-foreground' : 'text-muted-foreground',
                ].join(' ')}
              >
                {label}
              </span>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
